// the values need to match the field names instant-search saves it's state in
export enum FacetVariant {
  REFINEMENT_LIST = 'refinementList',
  RANGE = 'range',
}
